'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Geometry utils


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _lodash = require('lodash');

var _Vector = require('../../../common/maths/geometry/Vector');

var _Vector2 = _interopRequireDefault(_Vector);

var _lineControlPointUtil = require('./lineControlPointUtil');

var _rect = require('../../../common/maths/geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _ControlPointDragHandle = require('./ControlPointDragHandle');

var _ControlPointDragHandle2 = _interopRequireDefault(_ControlPointDragHandle);

var _lineConstants = require('../../../common/lines/lineConstants');

var _domUtil = require('../../utils/domUtil');

var _dndConstants = require('../../utils/dnd/dndConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var edgeDragSource = {
    beginDrag: function beginDrag(_ref, monitor, component) {
        var elementId = _ref.elementId,
            toggleLineVisibility = _ref.toggleLineVisibility,
            pos = _ref.pos,
            element = _ref.element;

        (0, _lodash.defer)(toggleLineVisibility);
        return { id: elementId, element: element, pos: pos };
    },
    endDrag: function endDrag(props, monitor) {
        var updateLineControlPoint = props.updateLineControlPoint,
            toggleLineVisibility = props.toggleLineVisibility,
            controlPoint = props.controlPoint,
            startEdgeOrigin = props.startEdgeOrigin,
            endEdgeOrigin = props.endEdgeOrigin,
            startConnectionRect = props.startConnectionRect,
            endConnectionRect = props.endConnectionRect;

        // Doing nothing if it was not dropped onto a compatible target

        var dropResult = monitor.getDropResult();
        if (!monitor.didDrop() || (0, _lodash.isEmpty)(dropResult)) {
            toggleLineVisibility();
            return;
        }

        var _dropResult$offsetDif = dropResult.offsetDiff,
            offsetDiff = _dropResult$offsetDif === undefined ? _dndConstants.NO_DRAG_OFFSET : _dropResult$offsetDif;


        var updatedControlPoint = _Vector2.default.fromObject(controlPoint)
        // Add the offset moved by the mouse
        .add(offsetDiff);

        // Snapping
        var controlPointPerpendicularMagnitude = (0, _lineControlPointUtil.calculateControlPointPerpendicularMagnitude)({
            controlPoint: updatedControlPoint,
            startEdgeOrigin: startEdgeOrigin,
            endEdgeOrigin: endEdgeOrigin
        });

        var controlPointParallelRatio = (0, _lineControlPointUtil.calculateControlPointParallelRatio)({
            controlPoint: updatedControlPoint,
            startEdgeOrigin: startEdgeOrigin,
            endEdgeOrigin: endEdgeOrigin
        });

        var control = void 0;
        var isControlPointWithinAnElement = rectLib.containsPoint(startConnectionRect, updatedControlPoint) || rectLib.containsPoint(endConnectionRect, updatedControlPoint);

        if ((0, _lineControlPointUtil.shouldSnapToStraight)({ controlPointPerpendicularMagnitude: controlPointPerpendicularMagnitude, controlPointParallelRatio: controlPointParallelRatio }) || isControlPointWithinAnElement) {
            control = null;
        } else {
            control = {
                perpMag: controlPointPerpendicularMagnitude,
                parallelRatio: controlPointParallelRatio
            };
        }

        updateLineControlPoint({ control: control });
        toggleLineVisibility();
    }
};

var dragCollect = function dragCollect(connector, monitor) {
    return {
        // Call inside render() to let React handle the drag event
        connectDragSource: connector.dragSource(),
        connectDragPreview: connector.dragPreview(),
        // Get current drag state from the monitor
        isDragging: monitor.isDragging()
    };
};

var ControlPointDragHandleDragSource = (_dec = (0, _reactDnd.DragSource)(_lineConstants.LINE_CONTROL_POINT_DND_TYPE, edgeDragSource, dragCollect), _dec(_class = function (_React$Component) {
    _inherits(ControlPointDragHandleDragSource, _React$Component);

    function ControlPointDragHandleDragSource() {
        _classCallCheck(this, ControlPointDragHandleDragSource);

        return _possibleConstructorReturn(this, (ControlPointDragHandleDragSource.__proto__ || Object.getPrototypeOf(ControlPointDragHandleDragSource)).apply(this, arguments));
    }

    _createClass(ControlPointDragHandleDragSource, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_ControlPointDragHandle2.default, this.props);
        }
    }]);

    return ControlPointDragHandleDragSource;
}(_react2.default.Component)) || _class);

/**
 * Needs to be a React component so that the parent's (Line) ref connects correctly.
 */
/* eslint-disable react/no-multi-comp */

var ConnectedControlPointDragHandle = function (_React$Component2) {
    _inherits(ConnectedControlPointDragHandle, _React$Component2);

    function ConnectedControlPointDragHandle() {
        var _ref2;

        var _temp, _this2, _ret;

        _classCallCheck(this, ConnectedControlPointDragHandle);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ConnectedControlPointDragHandle.__proto__ || Object.getPrototypeOf(ConnectedControlPointDragHandle)).call.apply(_ref2, [this].concat(args))), _this2), _this2.onDoubleClick = function (event) {
            _this2.props.updateLineControlPoint({ control: null });

            event.stopPropagation();
            event.preventDefault();
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(ConnectedControlPointDragHandle, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                controlPoint = _props.controlPoint,
                show = _props.show;

            if (!show) return null;

            return _react2.default.createElement(ControlPointDragHandleDragSource, _extends({ className: 'ControlPointDragHandle', isHitArea: true,
                onMouseDown: _domUtil.stopPropagationOnly, onDoubleClick: this.onDoubleClick,
                pos: controlPoint }, this.props));
        }
    }]);

    return ConnectedControlPointDragHandle;
}(_react2.default.Component);

ConnectedControlPointDragHandle.propTypes = {
    show: _propTypes2.default.bool,
    startEdgeOrigin: _propTypes2.default.object,
    endEdgeOrigin: _propTypes2.default.object,
    color: _propTypes2.default.string,
    controlPoint: _propTypes2.default.object,
    updateLineControlPoint: _propTypes2.default.func,
    startConnectionRect: _propTypes2.default.object,
    endConnectionRect: _propTypes2.default.object
};

exports.default = ConnectedControlPointDragHandle;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/ConnectedControlPointDragHandle.js
// module id = 1987
// module chunks = 0